import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {
  merchantInterest: {
    data: {},
    isSubmitting: false,
    submitFormSuccess: false
  }
};

export default function emailReducer(state = initState, action) {
  switch (action.type) {
    case actionTypes.SEND_MERCHANT_INTEREST_EMAIL: {
      let merchantInterest = cloneDeep(state.merchantInterest);
      merchantInterest.isSubmitting = true;
      merchantInterest.submitFormSuccess = false;

      return { ...state, merchantInterest };
    }

    case actionTypes.SEND_MERCHANT_INTEREST_EMAIL_SUCCESS: {
      let merchantInterest = cloneDeep(state.merchantInterest);
      merchantInterest.data = action.data;
      merchantInterest.isSubmitting = false;
      merchantInterest.submitFormSuccess = true;

      return {
        ...state,
        merchantInterest
      };
    }

    case actionTypes.SEND_MERCHANT_INTEREST_EMAIL_FAIL: {
      let merchantInterest = cloneDeep(state.merchantInterest);
      merchantInterest.isSubmitting = false;
      merchantInterest.submitFormSuccess = false;

      return {
        ...state,
        merchantInterest
      };
    }

    default:
      return state;
  }
}
